"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Subscription = /*#__PURE__*/function () {
  function Subscription(subscription) {
    _classCallCheck(this, Subscription);

    this.subscription = subscription;
  }

  _createClass(Subscription, [{
    key: "findProductIndex",
    value: function findProductIndex(productId) {
      if (this.subscription.upsell_orderlines) {
        return this.subscription.upsell_orderlines.findIndex(function (item) {
          return item.id === parseInt(productId);
        });
      }

      return -1;
    }
  }, {
    key: "addProduct",
    value: function addProduct(productData) {
      // console.log("Adding product to upsell_orderlines: ", productData);
      // Product not found, add it
      var orderline = {
        id: parseInt(productData.id),
        name: productData.translation.name,
        image: productData.image,
        price: parseFloat(productData.prices.price),
        number: 1,
        presale: false,
        region: "SPAIN",
        base_discount: parseFloat(productData.prices.base_discount),
        discounted: productData.prices.discounted,
        symbol: productData.prices.symbol,
        format: productData.prices.format,
        type: "club-upsell"
      };

      if (productData["variationsSelection"]) {
        orderline["variationsSelection"] = productData["variationsSelection"];
      }

      if (!this.subscription.upsell_orderlines) {
        this.subscription.upsell_orderlines = [];
      }

      this.subscription.upsell_orderlines.push(orderline);
      return this.subscription;
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(productId) {
      var productIndex = this.findProductIndex(productId);

      if (productIndex > -1) {
        this.subscription.upsell_orderlines.splice(productIndex, 1);
      }

      return this.subscription;
    }
  }, {
    key: "isNextProduct",
    value: function isNextProduct(productId) {
      if (this.subscription.next_product_id) {
        return this.subscription.next_product_id === parseInt(productId);
      }

      return this.subscription.next_product.id === parseInt(productId);
    }
  }, {
    key: "total",
    value: function total() {
      if (this.subscription.upsell_orderlines && this.subscription.upsell_orderlines.length > 0) {
        var price = this.subscription.subscription_data.price;
        var discountPercentage = this.subscription.subscription_data.discount || 0;
        var total = price * (1 - discountPercentage / 100);
        this.subscription.upsell_orderlines.forEach(function (orderline) {
          total += orderline.discounted * orderline.number;
        });
        return total.toFixed(2);
      }

      return null;
    }
  }]);

  return Subscription;
}();

exports["default"] = Subscription;